import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { AlertService } from 'src/app/services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CheckPermissionService } from 'src/app/services/check-permission.service';
import { AccessControlService } from 'src/app/services/access-control.service';
import { NgForm } from '@angular/forms';
import { modalConfigDefaults } from 'ngx-bootstrap/modal/modal-options.class';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { RoleTypeEnum } from 'src/app/enum/roles.enum';
// declare var $: any
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  @ViewChild('changepasswordForm') public changepasswordForm: NgForm
  model: any = {};
  user_id: any;
  id: any;
  is_submit: boolean = true;
  passwordPolicy: any;
  passwordError: any = { isError: false, errorMessage: '' };
  fromOtherConsumerApps=false;
  changeForUser=true;
  responseError:boolean=false;
  responseErrorText:any;
  isSavingData:boolean=false
  isLoading:boolean
  constructor(private authService: AuthService,
    private alertService: AlertService,
    private router: Router,
    private checkPermissionService: CheckPermissionService,
    private accessControlService: AccessControlService,
    private activatedRoute: ActivatedRoute,private location:Location,private toastService:ToastrService) {

    if (localStorage.getItem('passwordPolicy') != undefined) {
      this.passwordPolicy = JSON.parse(localStorage.getItem('passwordPolicy'));
    }
  }

  ngOnInit() {
   this.activatedRoute.params.subscribe(params=>{
     this.id=localStorage.getItem("defaultClient");
   })

  }

  ngOnChanges() {

  }

  changePassword() {

    if (!this.changepasswordForm.valid || this.model.confirm!=this.model.password ) {
      return
    }
      if (!this.validatePassword()) {
        this.isSavingData=true
        this.authService.changePassword(this.id, this.model).subscribe((res:any) => {
         if(res.status==401)
         {//this.toastService.error(res.message);
          this.responseError=true;
          this.responseErrorText=res.message;
        }
         else
         {
           this.toastService.success(res.message);
          this.changepasswordForm.resetForm();

         this.goBack();
          // if(RoleTypeEnum.CLIENT_ROLE==type )
          // this.router.navigate(["/user-dashboard/"+this.id]);
          // else{
          //   this.router.navigate(["/dashboard"]);
          // }
        }
        this.isSavingData=false
        }, error => {
          this.isSavingData=false
          this.alertService.errorAlertWithTitle(error.error,'Validation');
        });
    }

  }

  validatePassword() {
    this.responseError=false;
    this.passwordPolicy=this.passwordPolicy || {};
    this.passwordPolicy["regexValidators"]=[{"text":"Password should be Non-empty","value":"(.|\\s)*\\S(.|\\s)*"},{"text":"Password should be 8 characters in length","value":"^.{8,}$"},{"text":"Password should contain atleast 1 lowercase, 1 uppercase, 1 number","value":"(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).*"},{"text":"Password should contain atleast 1 special character","value":"[!@#$%^&*(),.?\":{}|<>]"}]
    if(this.passwordPolicy)
    if (this.passwordPolicy.regexValidators != undefined) {
      for (var i = 0; i < this.passwordPolicy.regexValidators.length; i++) {
        if (!this.model.password.match(this.passwordPolicy.regexValidators[i].value)) {
          this.passwordError.isError = true;
          this.passwordError.errorMessage = this.passwordPolicy.regexValidators[i].text;
          break;
        } else {
          this.passwordError.isError = false;
        }
      }
    }
    if(!this.passwordError.isError){
      if(this.model.password.startsWith(" ") || this.model.password.endsWith(" ")){
        this.passwordError.isError = true;
        this.passwordError.errorMessage="Password can't start or end with spaces";
      }
    }
    if(this.passwordPolicy && this.passwordPolicy.enforceCustumList)
    if (this.passwordPolicy.enforceCustumList != undefined && this.passwordPolicy.enforceCustumList) {
      var blacklist = this.passwordPolicy.customBannedList[0].split('\n');
      if (blacklist.some(item => item == this.model.password)) {
        this.passwordError.errorMessage = "This Password is in blacklist";
        this.passwordError.isError = true;
      }
    }
    return this.passwordError.isError;
  }
  goBack(){
    let  type=localStorage.getItem("type");
    if(type==="1")
    this.router.navigate([localStorage.getItem('org_name').toLowerCase().replace(/''/g,"-")+'/dashboard']);
    else{
      this.router.navigate(['/dashboard']);
    }
  }
}
